module.exports = __webpack_public_path__ + "static/img/6023_phase_function_Paper_Points.4feca35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6023_phase_function_Paper_Points.png
// module id = mamH
// module chunks = 0